module.exports = __webpack_public_path__ + "img/world.cc0a63bb.svg";